var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 385,
    viewBox: "0 0 539 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1224_33652)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.864 171.857C452.864 243.055 395.146 300.773 323.948 300.773C315.672 300.773 307.578 299.993 299.735 298.503C285.704 295.836 270.654 298.547 260.554 308.646L229.959 339.241C225.273 343.928 217.675 343.928 212.988 339.241V339.241C209.074 335.327 202.852 335.283 197.539 336.841C195.315 337.494 192.961 337.844 190.526 337.844C176.786 337.844 165.647 326.705 165.647 312.965C165.647 310.993 165.877 309.074 166.311 307.233C167.755 301.111 167.76 294.013 163.312 289.565V289.565C158.625 284.879 158.625 277.281 163.312 272.594L189.767 246.139C200.61 235.296 202.89 218.869 199.076 204.017C196.436 193.737 195.032 182.961 195.032 171.857C195.032 100.659 252.75 42.9414 323.948 42.9414C395.146 42.9414 452.864 100.659 452.864 171.857Z",
    fill: "url(#paint0_linear_1224_33652)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.516 142.545C429.859 94.4045 382.572 60.4807 327.361 60.4807C257.037 60.4807 199.568 115.52 195.68 184.871C195.251 180.592 195.031 176.25 195.031 171.857C195.031 100.659 252.749 42.9414 323.947 42.9414C385.062 42.9414 436.245 85.4687 449.516 142.545Z",
    fill: "url(#paint1_linear_1224_33652)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.015 247.106L302.11 143.591C304.343 140.668 308.64 140.382 311.241 142.983V142.983C313.317 145.059 313.613 148.323 311.943 150.739L301.44 165.937C296.775 172.687 305.529 180.572 311.757 175.229L324.135 164.609C326.787 162.334 330.743 162.485 333.214 164.956V164.956C335.625 167.367 335.834 171.208 333.698 173.867L323.567 186.481C318.422 192.887 326.612 201.385 333.203 196.481L346.622 186.496C349.3 184.503 353.034 184.776 355.394 187.136V187.136C358.246 189.989 357.964 194.693 354.79 197.184L252.986 277.077",
    stroke: "url(#paint2_linear_1224_33652)",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.838 152.247C437.838 223.446 380.12 281.163 308.922 281.163C302.97 281.163 297.111 280.76 291.373 279.979C278.067 278.168 264.117 281.164 254.622 290.659L217.771 327.511C213.084 332.197 205.486 332.197 200.8 327.511L165.008 291.718C167.72 296.107 167.533 302.023 166.304 307.232C165.87 309.073 165.641 310.992 165.641 312.964C165.641 326.704 176.779 337.843 190.519 337.843C192.955 337.843 195.308 337.493 197.533 336.84C202.845 335.282 209.067 335.326 212.982 339.241C217.668 343.927 225.266 343.927 229.952 339.241L260.548 308.645C270.647 298.546 285.697 295.835 299.729 298.502C307.571 299.992 315.665 300.772 323.942 300.772C395.14 300.772 452.858 243.055 452.858 171.856C452.858 137.95 439.767 107.1 418.365 84.0859C430.707 103.86 437.838 127.221 437.838 152.247Z",
    fill: "#080015"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "animatedGradient",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.299 177.313) scale(159.442 180.298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 0.87
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "white; #7551FF; white",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-opacity",
    values: "0.87; 0.4; 0.87",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7551FF",
    stopOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#7551FF; white; #7551FF",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-opacity",
    values: "0; 0.4; 0",
    dur: "4s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1224_33652",
    x1: 475.359,
    y1: 42.9414,
    x2: 235.731,
    y2: 401.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1224_33652",
    x1: 404.738,
    y1: 76.5394,
    x2: 242.935,
    y2: 404.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1224_33652",
    x1: 333.543,
    y1: 165.285,
    x2: 237.369,
    y2: 261.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1224_33652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.299 177.313) scale(159.442 180.298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_33652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 539,
    height: 385,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIdea);
export default __webpack_public_path__ + "static/media/TeamIdea.50a94a93fc6a0ced0c29d75536a2e988.svg";
export { ForwardRef as ReactComponent };